export default __webpack_public_path__ + "static/media/forestly-expl-02_DE.df58b2ad.png";